export default [
  'color',
  'date',
  'datetime-local',
  'email',
  'file',
  'hidden',
  'image',
  'month',
  'number',
  'password',
  'range',
  'reset',
  'search',
  'tel',
  'text',
  'time',
  'url',
  'week',
];
